import initShowRelease from '/builds/gitlab/gitlab-ee/app/assets/javascripts/releases/mount_show.js?vue3';

initShowRelease();
